import { get} from "../../service/axios";
import qs from "qs";

interface LogQueryOptions {
    limit?: number;
    offset?: number;
    search?: string;
    ordering?: string;
    succeeded?: boolean;

}

export async function apiGetHisLogs(options: LogQueryOptions = {}) {
    const { limit, offset, search, ordering,succeeded } = options;

    const params: Record<string, any> = {
        ...(limit !== undefined ? { limit } : {}),
        ...(offset !== undefined ? { offset } : {}),
        ...(ordering !== undefined ? { ordering } : {}),
        ...(succeeded !== undefined ? { succeeded } : {}),
        ...(search
            ? { search: search.includes(" ") ? `"${search.trim()}"` : search.trim() }
            : {}),
        ...(status !== "" ? { status } : {}),
    };

    return get("/logs/his/prescriptions/", {
        params,
        paramsSerializer: (params) =>
            qs.stringify(params, { arrayFormat: "repeat" }),
    });
}
export async function apiGetDeviceEventsLogs(options: LogQueryOptions = {}) {
    const { limit, offset, search, ordering,succeeded } = options;

    const params: Record<string, any> = {
        ...(limit !== undefined ? { limit } : {}),
        ...(offset !== undefined ? { offset } : {}),
        ...(ordering !== undefined ? { ordering } : {}),
        ...(succeeded !== undefined ? { succeeded } : {}),
        ...(search
            ? { search: search.includes(" ") ? `"${search.trim()}"` : search.trim() }
            : {}),
        ...(status !== "" ? { status } : {}),
    };

    return get("/logs/device/events/", {
        params,
        paramsSerializer: (params) =>
            qs.stringify(params, { arrayFormat: "repeat" }),
    });
}
export async function apiGetUserEventsLogs(options: LogQueryOptions = {}) {
    const { limit, offset, search, ordering,succeeded } = options;

    const params: Record<string, any> = {
        ...(limit !== undefined ? { limit } : {}),
        ...(offset !== undefined ? { offset } : {}),
        ...(ordering !== undefined ? { ordering } : {}),
        ...(succeeded !== undefined ? { succeeded } : {}),
        ...(search
            ? { search: search.includes(" ") ? `"${search.trim()}"` : search.trim() }
            : {}),
        ...(status !== "" ? { status } : {}),
    };

    return get("/logs/user/events/", {
        params,
        paramsSerializer: (params) =>
            qs.stringify(params, { arrayFormat: "repeat" }),
    });
}


export async function apiGetActivityDetail(id: string) {
    return get(`/activity/${id}/`);

}





